import * as restApi from "./restApi";

const collectionUrl = "api/division";
const enc = encodeURIComponent;

export const existsRecord = restApi.existsRecord.bind(null, {}, collectionUrl);
export const fetchRecord = restApi.fetchRecord.bind(null, {}, collectionUrl);
export const fetchRecords = restApi.fetchRecords.bind(null, {}, collectionUrl);
export const updateRecord = restApi.updateRecord.bind(null, {}, collectionUrl);
export const insertRecord = restApi.insertRecord.bind(null, {}, collectionUrl);
export const deleteRecord = restApi.deleteRecord.bind(null, {}, collectionUrl);

export const fetchDivisionPermissions = function (divisionId) {
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/permissions`);
};

export const addDivisionPermission = function (divisionId, permissionId) {
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/permissions`, permissionId, {});
};

export const removeDivisionPermission = function (divisionId, permissionId) {
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/permissions`, permissionId);
};

export const fetchDivisionSystems = function (divisionId) {
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/systems`);
};

export const addDivisionSystem = function (divisionId, manufacturerId, systemId) {
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/systems/${enc(manufacturerId)}`, systemId, {});
};

export const removeDivisionSystem = function (divisionId, manufacturerId, systemId) {
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/systems/${enc(manufacturerId)}`, systemId);
};

export const fetchManufacturers = function () {
  return restApi.fetchRecords({}, `${collectionUrl}/_manufacturers`);
};
